<template>
  <div>
    <el-card class="mb-1" style="box-shadow:none">
      <h5>{{ displaySampleSetName || '新增套件产品' }}</h5>
      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <div style="height: 29px;line-height: 29px;overflow: hidden;">
            <span style="font-size: 14px; color: #606266">
              <span class="mr-1">Style No:</span>
              <span>{{ baseInfo.sampleSetNo || '保存后自动生成' }}</span>
            </span>
            <el-divider direction="vertical" />
            <el-tag
              size="mini"
              :type="
                baseInfo.sampleSetStatus === 'S'
                  ? 'success'
                  : baseInfo.sampleSetStatus === 'N'
                  ? 'danger'
                  : ''
              "
            >
              {{ baseInfo.v_sampleSetStatus || 'New' }}
            </el-tag>
            <el-divider direction="vertical" />
            <span style="font-size: 14px; color: #606266">
              <span class="mr-1">Modify by:</span>
              <span>
                {{ baseInfo.modifyByName || '--' }} at
                {{ baseInfo.modifyDate || '--' }}
              </span>
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <div v-if="isAudit" class="mr-3" style="width: max-content;">
            <el-button size="small" type="success" @click="review">
              {{ $l('btn_setproofingReview') || '通过' }}
            </el-button>
            <!-- :disabled="baseInfo.sampleSetStatus !== 'Y'" -->
            <!-- <el-button
              size="small"
              type="warning"
              :disabled="baseInfo.sampleSetStatus !== 'S'"
              @click="reject"
            >
              {{ '驳回' }}
            </el-button> -->
          </div>
          <div class="switch-tabs_wrappers">
            <div class="switch-tabs">
              <div
                v-for="item in switchTabs"
                :key="item.value"
                class="switch-tabs_items"
                :class="{
                  active: item.value === activeName,
                  disabled: item.disabled,
                }"
                @click="!item.disabled ? (activeName = item.value) : () => {}"
              >
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <div>
      <el-card v-show="activeName == 'base'" style="box-shadow:none">
        <BaseForm
          ref="baseForm"
          :disabled="disabled"
          :sampleSetCode="sampleSetCode"
          :change="isChange"
          @loaded="(data) => (baseInfo = data)"
        />
        <div class="d-flex justify-content-end mb-2 mt-2">
          <el-button
            v-if="!disabled"
            type="primary"
            size="small"
            @click="$refs.baseForm.save()"
          >
            {{
              isChange
                ? $l('btn_change') || '变更'
                : $l('INDEX.btn_save') || '保存'
            }}
          </el-button>
        </div>
      </el-card>
      <el-card v-show="activeName == 'image'" style="box-shadow:none">
        <SampleImage
          :disabled="disabled"
          :sampleSetCode="sampleSetCode"
          :change="isChange"
          @reload="$refs.baseForm.reload()"
        />
      </el-card>
      <el-card v-show="activeName == 'material'" style="box-shadow:none">
        <SampleSetMaterial
          :disabled="disabled"
          :sampleSetCode="sampleSetCode"
          :productLine="baseInfo.productLine || 'ABSHome'"
          :categoryCode="baseInfo.masterCategoryCode"
          @reload="$refs.baseForm.reload()"
        />
      </el-card>
      <el-card v-show="activeName == 'sample'" style="box-shadow:none">
        <SetSample
          :disabled="this.sampleDisabled"
          :sampleSetCode="sampleSetCode"
          :baseInfo="baseInfo"
          :change="isChange"
          @reload="$refs.baseForm.reload()"
        />
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import BaseForm from '../components/base-form'
import SampleImage from '../components/sample-image'
import SampleSetMaterial from '../components/sample-set-material'
import SetSample from '../components/set-sample'
import EditLoading from '@/mixins/edit-loading'
export default {
  name: 'sample-setproofing-detail',
  mixins: [EditLoading],
  components: { BaseForm, SampleImage, SampleSetMaterial, SetSample },
  data() {
    return { baseInfo: {}, activeName: 'base' }
  },
  computed: {
    switchTabs() {
      return [
        { label: '基本信息', value: 'base' },
        { label: '样品图片', value: 'image', disabled: this.notCreate },
        { label: '辅料构成', value: 'material', disabled: this.notCreate },
        { label: '子件产品', value: 'sample', disabled: this.notCreate },
      ]
    },
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return ['detail', 'audit'].includes(this.pageType) || this.baseInfo?.sampleSetStatus == 'N'
    },
    isAudit() {
      return this.pageType == 'audit'
    },
    isChange() {
      return this.pageType == 'change'
    },
    sampleSetCode() {
      return this.params.sampleSetCode
    },
    displaySampleSetName() {
      const { sampleSetName, sampleSetNameEn } = this.baseInfo
      return [sampleSetName, sampleSetNameEn].filter(Boolean).join(' ')
    },
    sampleDisabled() {
      return this.baseInfo.sampleSetStatus != 'S' || this.disabled
    },
    notCreate() {
      const { sampleSetCode } = this.baseInfo
      return !sampleSetCode
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    async review() {
      const confirm = await this.$confirm(
        this.$l('tips_setproofing_review') || '是否通过当前样品套件的审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .sampleSetInfoReviewApi({ sampleSetCode: this.sampleSetCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_audit_failure') || '审核失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_audit_success') || '审核成功！',
        type: 'success',
      })

      this.$eventBus.$emit('setproofing-table-reload')
      this.close({ tagName: this.$route.fullPath, showConfirm: false })
    },
    async reject() {
      const confirm = await this.$confirm(
        this.$l('tips_setproofing_reject') || '是否驳回当前样品套件的审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .sampleSetInfoRejectApi({ sampleSetCode: this.sampleSetCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_reject_failed') || '驳回失败！')
        return
      }
      this.$message({
        message: this.$l('tips_reject_success') || '驳回成功！',
        type: 'success',
      })

      this.$eventBus.$emit('setproofing-table-reload')
      this.close({ tagName: this.$route.fullPath, showConfirm: false })
    },
  },
}
</script>
<style lang="scss" scoped>
.switch-tabs {
  display: flex;
  .switch-tabs_items {
    padding: 4px 8px;
    color: #6c757d;
    font-size: 14px;
    margin-right: 20px;
    border-radius: 4px;
    cursor: pointer;
    min-width: max-content;
  }
  .switch-tabs_items:hover,
  .switch-tabs_items.active {
    color: #007bff;
    background-color: #f8f8f9;
  }
  .switch-tabs_items.disabled {
    cursor: no-drop;
  }
  .switch-tabs_items.disabled:hover {
    color: #8cc5ff;
  }
  .switch-tabs_items:last-child {
    margin-right: 0;
  }
}

::v-deep {
  .el-card__body {
    padding: 18px;
  }
}
</style>
